"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePicturePlaceholder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const imurmurhash_1 = __importDefault(require("imurmurhash"));
const Placeholder_1 = require("./icons/Placeholder");
/**
 * Returns a placeholder image of a consistent color for a given user id
 */
function ProfilePicturePlaceholder({ id }) {
    const colors = [
        "#336B21",
        "#C62937",
        "#DF4C5B",
        "#FF6777",
        "#2A3E90",
        "#2B4DD6",
        "#5172F3",
        "#4FAAF8",
        "#5C2A80",
        "#7F3BB0",
        "#AF5CEB",
        "#549C3E",
        "#C890F1",
        "#8E1D59",
        "#AF246E",
        "#D23689",
        "#FA6EB8",
        "#296C5B",
        "#368D77",
        "#2CB794",
        "#85CCBA",
        "#6C4129",
        "#6CC651",
        "#985B38",
        "#CF7B4C",
        "#FFAD80",
        "#B3DB4A",
        "#BE5122",
        "#E46429",
        "#FC854F",
        "#F4B76D",
        "#A32018",
    ];
    const hashState = Math.floor((0, imurmurhash_1.default)(id).result());
    const index = Math.abs(hashState) % colors.length;
    return (0, jsx_runtime_1.jsx)(Placeholder_1.Placeholder, { color: colors[index] });
}
exports.ProfilePicturePlaceholder = ProfilePicturePlaceholder;
//# sourceMappingURL=ProfilePicturePlaceholder.js.map